export default "__VITE_ASSET__IzFPcxao__"